/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

export const updateAlbumTrackOrderBodySchema = z.object({
    "trackId": z.string().uuid().describe("Идентификатор трека."),
"rowNumber": z.number().int().describe("Номер позиции в списке.")
    })